import {ValidationErrorKeys} from '@hconnect/common/consts'
import {type TFunction} from 'i18next'
import {object, string} from 'yup'

import {YesNoFormValue} from '../../types'

import {COMMENT_MAX_LENGTH, getYesNoWithCommentSchema, TEXT_MAX_LENGTH} from './yes-no.validators'

export const getAdditionalCommentsSectionValidationSchema = ({t}: {t: TFunction}) =>
  object().shape({
    checkLinesForOilLeaksOrSpills: string()
      .oneOf([YesNoFormValue.YES, YesNoFormValue.NO])
      .required(t(ValidationErrorKeys.REQUIRED)),
    checkLinesForOilLeaksOrSpillsActionTaken: string().max(
      COMMENT_MAX_LENGTH,
      t(ValidationErrorKeys.MAX_LENGTH, {max: TEXT_MAX_LENGTH})
    ),
    jackhammerInServerRoom: getYesNoWithCommentSchema({t}),
    jackhammerInCabinetByClinkerBreaker: getYesNoWithCommentSchema({t})
  })
